import { render, staticRenderFns } from "./LoginCognitoAuth.vue?vue&type=template&id=74d512c8&"
import script from "./LoginCognitoAuth.vue?vue&type=script&lang=js&"
export * from "./LoginCognitoAuth.vue?vue&type=script&lang=js&"
import style0 from "./LoginCognitoAuth.vue?vue&type=style&index=0&id=74d512c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports